import { render, staticRenderFns } from "./TeacherInfoForm.vue?vue&type=template&id=4bb7352a"
import script from "./TeacherInfoForm.vue?vue&type=script&lang=js"
export * from "./TeacherInfoForm.vue?vue&type=script&lang=js"
import style0 from "./TeacherInfoForm.vue?vue&type=style&index=0&id=4bb7352a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})
